import React, { useState } from "react";
import {
  Row,
  Col,
  Card,
} from "react-bootstrap";
import { Link } from "react-router-dom";
import CopyToClipboard from "../../../_Components/CopyToClipboard";
import ViewHistoryOrderPerson from "../../../Orders/components/UserOrderPerson/ModalViewHistoryOrderPerson/ViewHistoryOrderPerson.js";
import { ViewAgentDetails } from "../../../Orders/components/UserOrderPerson/ModalViewAgentDetails/ViewAgentDetails";

function UserOrderPersonIndex(props) {
  const [showModalHistoryOrder, setShowModalHistoryOrder] = useState(false);
  const [showModalAgent, setShowModalAgent] = useState(false);

  const service = props.service;

  const handleShowHistoryOrder = () => {
    setShowModalHistoryOrder(!showModalHistoryOrder);
  };

  let showPrice = Intl.NumberFormat("en-US");

  return (
    <>
      {/* --------------------------مودال های مورد استفاده در این بخش--------------------------------------------------------------------------------------- */}
      {showModalHistoryOrder && <ViewHistoryOrderPerson callBack={handleShowHistoryOrder} basketId={props.basketId} />}

      {/* --------------------------نمایش اطلاعات فرد سفارش دهنده -------------------------------------------------------------------------------------------- */}
      <Card className="bg-wihte w-100 mt-0 mb-4 p-3 rounded-xl  border border-secondary">
        <Row className="align-items-center border-bottom">
          <Col xs xl className="d-flex align-items-center ml-2">
            {service?.basket?.creatorType == 1 ? (
              <>
                <h3 className="mr-3 mt-3  mb-3 fs-large">
                  نماینده فروش: {service?.userOrderSelected?.firstName + " " + service?.userOrderSelected?.lastName}
                </h3>
              </>
            ) : (
              <div className="mb-3">
                <CopyToClipboard
                  showIcon={true}
                  copyDate={service?.userOrderSelected?.firstName + " " + service?.userOrderSelected?.lastName}
                  htmlText={
                    `<div className="m-0 p-0">
              <h3 className="mx-3 pl-2 mt-3 mb-0 text-hover-primary cursor-pointer fs-large" data-toggle="tooltip" data-placement="top" title="برای کپی کلیک کنید"
                >` +
                    service?.userOrderSelected?.firstName +
                    " " +
                    service?.userOrderSelected?.lastName +
                    `</h3>
            </div>`
                  }
                ></CopyToClipboard>
              </div>
            )}
          </Col>

          <Col xs="auto">
            <div className="btn-group-sm d-flex justify-content-end mb-3 ">
              <button type="button" className="btn btn-light-primary btn-text mx-1" onClick={() => props.callBack()}>
                <p className="fas fa-sync fa-sm my-0"></p>
              </button>
              <button type="button" className="btn btn-light-secondary btn-text mx-1" onClick={handleShowHistoryOrder}>
                <p className="fas fa-history text-dark fa-sm my-0"></p>
              </button>
            </div>
          </Col>
        </Row>

        <Row className="pt-5 pb-3">
          <Col xs="12" sm="6" md="4" lg="6" xl="3" className="my-1">
            {service?.basket?.creatorType == 1 ? (
              <CopyToClipboard
                showIcon={true}
                copyDate={service?.basket?.mobile}
                htmlText={
                  `<span className="mx-3 cursor-pointer " data-toggle="tooltip" data-placement="top" title="برای کپی کلیک کنید"> <span className="text-hover-primary"> ` +
                  service?.basket?.mobile +
                  ` <i className="mr-2 fas fa-phone fa-sm text-hover-primary flipX"></i> </span>    </span>`
                }
              ></CopyToClipboard>
            ) : (
              <CopyToClipboard
                showIcon={true}
                copyDate={service?.userOrderSelected?.phoneNumber}
                htmlText={
                  `<span className="mx-3 cursor-pointer " data-toggle="tooltip" data-placement="top" title="برای کپی کلیک کنید"> <span className="text-hover-primary"> ` +
                  service?.userOrderSelected?.phoneNumber +
                  ` <i className="mr-2 fas fa-phone fa-sm text-hover-primary flipX"></i> </span>    </span>`
                }
              ></CopyToClipboard>
            )}
          </Col>
          <Col xs="12" sm="6" md="4" lg="6" xl="3" className="my-1 d-flex align-items-center">
            <span className="mr-3 text-muted ">
              {" "}
              <small className="fas fa-shopping-basket"></small>
              <span className="mx-2 ">مجموع سبد خرید : {showPrice.format(service?.basket?.price)} تومان</span>
            </span>
          </Col>
          <Col xs="12" sm="6" md="4" lg="6" xl="3" className="my-1 d-flex align-items-center">
            <span className="mx-3 text-muted ">
              <small className="fas fa-gift"></small>
              <span className="mx-2 ">
                {" "}
                تخفیف:
                {service?.basket?.originalPrice && service?.basket?.salePrice
                  ? showPrice.format(service?.basket?.originalPrice - service?.basket?.salePrice)
                  : "---"}
              </span>
            </span>
          </Col>
          <Col xs="12" sm="6" md="4" lg="6" xl="3" className="my-1 d-flex align-items-center">
            <span className="mx-3 text-muted ">
              <small className="fas fa-gift"></small>
              <span className="mx-2 ">
                {" "}
                تخفیف کد:
                {service?.basket?.promoCodeDiscountPrice
                  ? showPrice.format(service.basket.promoCodeDiscountPrice)
                  : "---"}
              </span>
            </span>
          </Col>
          <Col xs="12" sm="6" md="4" lg="6" xl="3" className="my-1 d-flex align-items-center">
            <span className={`${service?.basket?.promoCodeCode ? " fw-bold text-info" : "text-muted"} `}>
              <small className="fas fa-gift"></small>
              <span className="mx-2">
                کد تخفیف:{service?.basket?.promoCodeCode ? service.basket.promoCodeCode : "---"}
              </span>
            </span>
          </Col>
          {service?.basket?.commisonAgentCompanyName && (
            <Col xs="12" sm="6" md="4" lg="6" xl="3" className=" d-flex align-items-center my-1">
              <span className={`d-inline-block btn btn-outline-info btn-sm`} onClick={() => setShowModalAgent(true)}>
                مشاهده جزئیات نماینده
              </span>
            </Col>
          )}
          {/* <Col xs="12" sm="6" md="4" lg="6" xl="3" className="my-1 d-flex align-items-center">
            <span className={` ${service?.basket?.commisonAgentCompanyName ? " fw-bold text-info" : " text-muted "}`}>
              <small className="fas fa-user"></small>
              <span className="mx-2">
                نماینده فروش:
                {service?.basket?.commisonAgentCompanyName ? service.basket.commisonAgentCompanyName : "---"}{" "}
              </span>
            </span>
          </Col> */}

          <Col xs="12" sm="6" md="4" lg="6" xl="3" className="my-1">
            <span className="mx-3 text-muted ">
              <span className="text-hover-primary">
                <small className="fas fa-info-circle"></small>
                <Link
                  to={"/viewOrderContents/" + props.basketId}
                  className="text-muted font-weight-bold text-hover-primary"
                  target={"_blank"}
                >
                  {" "}
                  اطلاعات کامل سفارش{" "}
                </Link>
              </span>{" "}
            </span>
          </Col>
        </Row>
      </Card>
      {showModalAgent && (
        <ViewAgentDetails
          showModalAgent={showModalAgent}
          setShowModalAgent={setShowModalAgent}
          selectedAgent={service?.basket?.commisonAgentId}
        />
      )}
    </>
  );
}

export default UserOrderPersonIndex;
